const firebaseConfig = {
    apiKey: "AIzaSyC1eusbMnnlzBhpSKhfQSJMnCJazOYdIP0",
    authDomain: "ace-holidays.firebaseapp.com",
    projectId: "ace-holidays",
    storageBucket: "ace-holidays.appspot.com",
    messagingSenderId: "130575952633",
    appId: "1:130575952633:web:d0f61e1482f4c7bc1a9028"



    // i got stuck for about 2hours for this environment variable. so that i use default firebse config.

    // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    // appId: process.env.REACT_APP_FIREBASE_APP_ID
};

export default firebaseConfig;